import ContentEmpty from './ContentEmpty';

export default ContentEmpty;
